/**
 * Jackpot View
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseReplacerView = require('common/base.replacer.view');
    var jackpotModel = require('replacers/jackpot/jackpot.model.instance');

    require('widgets/ticker.widget');

    module.exports = BaseReplacerView.extend({

        render: function(jackpotCode) {
            this.jackpotCode = jackpotCode;
            this.$el.html(this.tmpl('jackpot'));
            this.initJackpotTicker();

            return this;
        },

        subscribe: function() {
            this.listenToOnce(jackpotModel, 'change', this.initJackpotTicker);
        },

        initJackpotTicker: function() {
            var modelData = jackpotModel.toJSON();
            var getJackpot = _.property(this.jackpotCode || '0');
            var source = modelData[this.jackpotCode && 'jackpots' || 'totals'];
            var jackpot = getJackpot(source);

            if (jackpot) {
                jackpot = Array.isArray(jackpot) ? jackpot[0] : jackpot;
                this.attachWidget(this.$('.jackpot-wrapper').ticker(jackpot));
            }
        },

        /**
         * @deprecated Don't use
         */
        afterRender: _.noop,

        /**
         * @deprecated
         * jackpot model no longer fetching here,
         * it is subscribing on necessary events and do that itself,
         * jackpot view only read model data
         */
        onSuccessJackpotResponse: _.noop,

        /**
         * @deprecated Don't use
         */
        onFailedJackpotResponse: _.noop
    }, {
        nameOfReplacers: [
            'JACKPOTS',
            'JACKPOT'
        ]
    });
});
